import { configurations } from './configurations'
import { permissions } from './permissions'

export const appRoutes = {
    routePaths: Object.freeze({
        dashboard: Object.freeze({
            path: '/dashboard',
            value: 'Dashboard',
        }),

        // OPS TOOLS
        stores: Object.freeze({
            path: '/dashboard/stores',
            value: 'Stores',
            config_feature_key: configurations.configFeatureFlags.OPS,
            permission: permissions['APP-7NOWMANAGER-STORE-READ'],
        }),
        store_details: Object.freeze({
            path: '/dashboard/stores/:storeId',
            value: 'Store Details',
            config_feature_key: configurations.configFeatureFlags.OPS,
            permission: permissions['APP-7NOWMANAGER-STORE-READ'],
        }),
        orders: Object.freeze({
            path: '/dashboard/orders',
            value: 'Orders',
            config_feature_key: configurations.configFeatureFlags.OPS,
            permission: permissions['APP-7NOWMANAGER-ORDER-READ'],
        }),
        order_details: Object.freeze({
            path: '/dashboard/orders/:orderId',
            value: 'Order Details',
            config_feature_key: configurations.configFeatureFlags.OPS,
            permission: permissions['APP-7NOWMANAGER-ORDER-READ'],
        }),

        // PROMOTIONS
        promotions: Object.freeze({
            path: '/dashboard/manage-promotions',
            value: 'Promotions',
            config_feature_key: configurations.configFeatureFlags.PROMOTIONS,
            permission: permissions['APP-7NOWMANAGER-PROMOTION-READ'],
        }),
        promo_details: Object.freeze({
            path: '/dashboard/manage-promotions/:promoId',
            value: 'Promo Details',
            config_feature_key: configurations.configFeatureFlags.PROMOTIONS,
            permission: permissions['APP-7NOWMANAGER-PROMOTION-READ'],
        }),
        marketing: Object.freeze({
            path: '/dashboard/manage-promotions/:promoId/marketing',
            value: 'Marketing',
            config_feature_key: configurations.configFeatureFlags.PROMOTIONS,
            permission: permissions['APP-7NOWMANAGER-PROMOTION-READ'],
        }),
        prioritize_promos: Object.freeze({
            path: '/dashboard/prioritize-promos',
            value: 'Prioritize Promos',
            config_feature_key: configurations.configFeatureFlags.PROMOTIONS,
            permission: permissions['APP-7NOWMANAGER-PROMOTION-READ'],
        }),

        // PUSH NOTIFICATIONS
        push_notifications: Object.freeze({
            path: '/dashboard/push-notifications',
            value: 'Push Notifications',
            config_feature_key: configurations.configFeatureFlags.PUSH_NOTIFICATIONS,
            permission: permissions['APP-7NOWMANAGER-NOTIFICATION-READ'],
        }),
        push_notification_details: Object.freeze({
            path: '/dashboard/push-notifications/:notificationId',
            value: 'Push Notifications Details',
            config_feature_key: configurations.configFeatureFlags.PUSH_NOTIFICATIONS,
            permission: permissions['APP-7NOWMANAGER-NOTIFICATION-READ'],
        }),

        // DATA MANAGEMENT
        manage_stores_imports: Object.freeze({
            path: '/dashboard/manage-stores-imports',
            value: 'Manage Stores Imports',
            config_feature_key: configurations.configFeatureFlags.MANAGEMENT_DATA,
            permission: permissions['APP-7NOWMANAGER-STOREIMPORT-READ'],
        }),
        manage_store_import: Object.freeze({
            path: '/dashboard/manage-store-import/:storeId/:_id',
            value: 'Manage Store Import',
            config_feature_key: configurations.configFeatureFlags.MANAGEMENT_DATA,
            permission: permissions['APP-7NOWMANAGER-STOREIMPORT-READ'],
        }),
        add_new_store_import: Object.freeze({
            path: '/dashboard/add-new-store-import',
            value: 'Add New Store Import',
            config_feature_key: configurations.configFeatureFlags.MANAGEMENT_DATA,
            permission: permissions['APP-7NOWMANAGER-STOREIMPORT-WRITE'],
        }),
        manage_products_imports: Object.freeze({
            path: '/dashboard/manage-products-imports',
            value: 'Manage Products Imports',
            config_feature_key: configurations.configFeatureFlags.MANAGEMENT_DATA,
            permission: permissions['APP-7NOWMANAGER-PRODUCTIMPORT-READ'],
        }),
        manage_product_import: Object.freeze({
            path: '/dashboard/manage-product-import/:productId/:_id',
            value: 'Manage Product Import',
            config_feature_key: configurations.configFeatureFlags.MANAGEMENT_DATA,
            permission: permissions['APP-7NOWMANAGER-PRODUCTIMPORT-READ'],
        }),
        add_new_product_import: Object.freeze({
            path: '/dashboard/add-new-product-import',
            value: 'Add New Product Import',
            config_feature_key: configurations.configFeatureFlags.MANAGEMENT_DATA,
            permission: permissions['APP-7NOWMANAGER-PRODUCTIMPORT-WRITE'],
        }),
        manage_inventory_imports: Object.freeze({
            path: '/dashboard/manage-inventory-imports',
            value: 'Manage Inventory Imports',
            config_feature_key: configurations.configFeatureFlags.MANAGEMENT_DATA,
            permission: permissions['APP-7NOWMANAGER-INVENTORYIMPORT-READ'],
        }),
        manage_nutrition_imports: Object.freeze({
            path: '/dashboard/manage_nutrition_imports',
            value: 'Manage Nutrition Imports',
            config_feature_key: configurations.configFeatureFlags.MANAGEMENT_DATA,
            permission: permissions['APP-7NOWMANAGER-INVENTORYIMPORT-READ'],
        }),
        manage_inventory_import: Object.freeze({
            path: '/dashboard/manage-inventory-import/:storeId/:productId/:_id',
            value: 'Manage Inventory Import',
            config_feature_key: configurations.configFeatureFlags.MANAGEMENT_DATA,
            permission: permissions['APP-7NOWMANAGER-INVENTORYIMPORT-READ'],
        }),
        add_new_inventory_import: Object.freeze({
            path: '/dashboard/add-new-inventory-import',
            value: 'Add New Inventory Import',
            config_feature_key: configurations.configFeatureFlags.MANAGEMENT_DATA,
            permission: permissions['APP-7NOWMANAGER-INVENTORYIMPORT-WRITE'],
        }),

        // ASSORTMENT
        products: Object.freeze({
            path: '/dashboard/products',
            value: 'Manage Products',
            config_feature_key: configurations.configFeatureFlags.ASSORTMENT,
            permission: permissions['APP-7NOWMANAGER-PRODUCT-READ'],
        }),
        products_product_details: Object.freeze({
            path: '/dashboard/products/:productId',
            value: 'Product Details',
            config_feature_key: configurations.configFeatureFlags.ASSORTMENT,
            permission: permissions['APP-7NOWMANAGER-PRODUCT-READ'],
        }),
        manage_updates: Object.freeze({
            path: '/dashboard/manage-updates',
            value: 'Manage Updates',
            config_feature_key: configurations.configFeatureFlags.ASSORTMENT,
            permission: permissions['APP-7NOWMANAGER-PRODUCT-READ'],
        }),
        manage_update_product_details: Object.freeze({
            path: '/dashboard/manage-updates/:productDraftId',
            value: 'Product Details',
            config_feature_key: configurations.configFeatureFlags.ASSORTMENT,
            permission: permissions['APP-7NOWMANAGER-PRODUCT-READ'],
        }),
        add_new_products: Object.freeze({
            path: '/dashboard/add-new-products',
            value: 'Add New Products',
            config_feature_key: configurations.configFeatureFlags.ASSORTMENT,
            permission: permissions['APP-7NOWMANAGER-PRODUCT-READ'],
        }),
        product_details: Object.freeze({
            path: '/dashboard/add-new-products/:productDraftId',
            value: 'Product Details',
            config_feature_key: configurations.configFeatureFlags.ASSORTMENT,
            permission: permissions['APP-7NOWMANAGER-PRODUCT-READ'],
        }),
    }),
}
